function parseNonEmptyNumericInput(value: string | number): number {
    if (typeof value === 'number') return value;

    const parsedValue = parseFloat(value.replaceAll(' ', '').replace(',', '.'));
    const newValue = Number.isNaN(parsedValue) ? 0 : parsedValue;
    return newValue;
}

export function parseNumericInput(
    value: string | number | undefined,
): number | '' {
    if (value === undefined || value === '') return '';
    return parseNonEmptyNumericInput(value);
}
export function parseNumericInputOrDefault(value: string | undefined): number {
    if (!value || value === '') return 0;
    return parseNonEmptyNumericInput(value);
}
